import * as React from 'react';
import { ActionButton, IButtonProps } from '../../button';
import styled from 'styled-components';

export interface INavigationButtonProps extends IButtonProps {
}

function TabNavigationButtonBase(props: INavigationButtonProps) {
    const { onClick, ref, ...rest } = props;
    const _onClick = React.useCallback((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        if (onClick) {
            onClick(e);
        }
    }, [onClick]);

    return (
        <ActionButton {...rest} onClick={_onClick} />
    );
}

export const TabNavigationButton = styled(TabNavigationButtonBase)`
    max-height: 100%;
    position: relative;
`;

TabNavigationButton.defaultProps = {
    iconSize: '12'
};
